export interface DataEntity_Working_05_Interface {
  id: number,
  value:string,
}

export function Empty_DataEntity_Working_05_Interface(): DataEntity_Working_05_Interface {
  return {
    id: 0,
    value:'',
  }
}
